import { useContentObjectType } from 'content-management-data-lib';
import { ContentObjectTypes } from 'content-management-data-lib/constants/ContentObjectTypes';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { useMemo } from 'react';
export const requestFetchPersonalizationVariants = ({
  contentId,
  contentObjectType
}) => {
  const contentTypeSlug = contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing-pages' : 'site-pages';
  return http.get(`cospages/v2/${contentTypeSlug}/${contentId}/personalized-variants`);
};
const fetchPersonalizationVariantsQuery = registerQuery({
  fieldName: 'personalizationVariants',
  args: ['contentId'],
  fetcher: requestFetchPersonalizationVariants
});
export const useFetchPersonalizationVariants = (contentId, shouldFetchData = true) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(fetchPersonalizationVariantsQuery, {
    variables: {
      contentId,
      contentObjectType
    },
    skip: !shouldFetchData
  });
  return useMemo(() => ({
    personalizationVariants: (data === null || data === void 0 ? void 0 : data.personalizationVariants) || [],
    error,
    loading,
    refetch
  }), [data, error, loading, refetch]);
};